import React, { Component } from 'react';
import { Button, Popover, UncontrolledTooltip } from 'reactstrap';
import PropTypes from 'prop-types';
import './Menu.css';

class Menu extends Component {
  static propTypes = {
    menuKey: PropTypes.string.isRequired,
    containerClassName: PropTypes.string,
    popoverClassName: PropTypes.string,
    buttonName: PropTypes.string,
    detailsMenu: PropTypes.array.isRequired,
    tooltipText: PropTypes.string,
    buttonComponent: PropTypes.any,
    isBig: PropTypes.bool
  };
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  toggleMenu = () => this.setState(prevState => ({ isOpen: !prevState.isOpen }));

  onMenuClick = onClick => {
    if (onClick) {
      onClick();
    }
    this.toggleMenu();
  };

  render() {
    const {
      menuKey,
      containerClassName,
      popoverClassName,
      detailsMenu,
      tooltipText,
      buttonComponent,
      isBig
    } = this.props;

    return (
      <div className={`detailsMenu ${containerClassName}`}>
        <div>
          <div onClick={this.toggleMenu} id={`menu_btn_${menuKey}`}>
            {buttonComponent ? buttonComponent : this.getDefaultButton()}
          </div>
          {tooltipText && isBig && (
            <UncontrolledTooltip
              placement="top"
              target={`menu_btn_${menuKey}`}
              className="tooltip-white"
              innerClassName="tooltipInner">
              {tooltipText}
            </UncontrolledTooltip>
          )}
        </div>
        <Popover
          placement="bottom"
          hideArrow={true}
          isOpen={this.state.isOpen}
          target={`menu_btn_${menuKey}`}
          toggle={this.toggleMenu}
          className={`popover ${popoverClassName}`}>
          <div className={'menuOptions'}>
            {detailsMenu.map(element => (
              <button
                key={element.id}
                id={element.id}
                disabled={element.disabled}
                data-clipboard-text={element.clipboardText}
                className="dropdown-item"
                onClick={() => this.onMenuClick(element.onClick)}>
                <div className={`${element.iconClassName}`} />
                <div className={'itemText'}>{element.text}</div>
              </button>
            ))}
          </div>
        </Popover>
      </div>
    );
  }
  getDefaultButton = () => {
    const { buttonName } = this.props;
    return (
      <Button color="link" className="menuButton" onClick={this.toggleMenu}>
        {buttonName}
      </Button>
    );
  };
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.js